import request from '../request';
import { lookupAPI } from './urls';

// WI-433: BigQuery data-storage locations + default, owned and validated by the backend.
const getDataStorageLocations = () => {
  return request({
    url: lookupAPI.dataStorageLocations,
    method: 'GET',
  })
    .then((response) => response)
    .catch((error) => error);
};

const lookupService = {
  getDataStorageLocations,
};

export default lookupService;
